import {JOURNEY_STATUS_TYPES} from '@/consts/loyalty/journeyStatusTypes';
import amplitudeLoyaltyTracking from '@/services/analytics/amplitude/amplitudeLoyaltyTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import {setJourneyBadgePending, setJourneyLevelTaskPending} from '@/state/slices/loyaltySlice';
import {dispatch} from '@/state/store';

export const isJourneyCompleted = ({memberJourneyStatus} = {}) => {
    return memberJourneyStatus === JOURNEY_STATUS_TYPES.COMPLETED;
};

export const isJourneyActionCompleted = (levelAction) => {
    return levelAction?.memberJourneyActionStatus === JOURNEY_STATUS_TYPES.COMPLETED;
};

export const isJourneyActionNotStarted = (levelAction) => {
    return levelAction?.memberJourneyActionStatus === JOURNEY_STATUS_TYPES.NOT_STARTED;
};

export const isJourneyLevelInProgress = ({actionsLeft, memberJourneyActions} = {}) => {
    return actionsLeft > 0 && actionsLeft <= memberJourneyActions?.length;
};

export const isJourneyLevelCompleted = ({actionsLeft} = {}) => {
    return actionsLeft === 0;
};

export const isJourneyInProgress = ({memberJourneyStatus} = {}) => {
    return memberJourneyStatus === JOURNEY_STATUS_TYPES.IN_PROGRESS;
};

export const getJourneyInfo = ({journeyLevels, memberJourneyStatus: isMemberJourney} = {}) => {
    const levels = journeyLevels || [];
    let actionsLeft = 0;
    let actionsCount = 0;
    let currentLevel = null;
    let completedLevels = 0;

    for (const level of levels) {
        const actions = isMemberJourney ? level.memberJourneyActions : level.journeyActions;

        const levelActionsCount = actions?.length || 0;

        actionsCount += levelActionsCount;
        actionsLeft += isNaN(level.actionsLeft) ? actions?.length : level.actionsLeft;

        if (isJourneyLevelCompleted(level)) {
            completedLevels += 1;
            continue;
        }
        if (!isJourneyLevelInProgress(level)) {
            continue;
        }
        if (!currentLevel) {
            currentLevel = level;
        }
    }

    const isSingleLevel = levels.length === 1;

    // If no level is in progress, set the badge to the last level's badge
    currentLevel ??= levels[isMemberJourney ? levels.length - 1 : 0] || {};
    const currentLevelBadge = currentLevel?.memberJourneyBadge || currentLevel?.journeyBadge || null;

    const progressCompleted = isSingleLevel ? actionsCount - actionsLeft : completedLevels;
    const progressTotal = isSingleLevel ? actionsCount : levels.length;

    return {
        actionsLeft,
        actionsCount,
        currentLevelBadge,
        currentLevel,
        progressCompleted,
        progressTotal,
        isSingleLevel,
    };
};

export const getJourneyAction = (journeys, {actionIndex, levelIndex, journeyId} = {}) => {
    const level = journeys?.find((journey) => journey.journeyId === journeyId)?.journeyLevels[levelIndex];

    if (!level) return null;
    const action = (level.memberJourneyActions || level.journeyActions)[actionIndex];

    if (!action) return null;

    return {...action, memberJourneyBadge: level.memberJourneyBadge || level.journeyBadge};
};

export const getJourneyLevelProgress = (journeyLevel = {}) => {
    const memberJourneyActions = journeyLevel.memberJourneyActions || journeyLevel.journeyActions;
    const progressCount = memberJourneyActions?.filter(isJourneyActionCompleted)?.length || 0;
    const totalCount = memberJourneyActions?.length || 0;
    const lastNotCompletedAction = memberJourneyActions?.find((action) => !isJourneyActionCompleted(action));

    return {progressCount, totalCount, lastNotCompletedAction, isCompleted: progressCount === totalCount};
};

export const trackLoyaltyClick = (badgeId) => {
    amplitudeLoyaltyTracking.trackBadgeDetailsClick(badgeId);
    googleAnalyticsService.trackBadgeDetailsClick(badgeId);
    dispatch(setJourneyBadgePending(true));
    dispatch(setJourneyLevelTaskPending(true));
};
